import { IdealistDayEvent as ApiIdealistDayEvent } from 'api/orgAdmin';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../../actions/orgDashboard/idealistDayEvents';

export type IdealistDayEvent = ApiIdealistDayEvent & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, IdealistDayEvent>;
};
export default function events(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_REQUEST':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.eventId]: {
            ...state.byId[action.eventId],
            id: action.eventId,
            isFetching: true,
          },
        },
      };

    case 'ORG_DASHBOARD_FETCH_IDEALIST_DAY_EVENT_SUCCESS': {
      const { event } = action;
      const newState = {
        ...state,
        byId: {
          ...state.byId,
          [event.id]: { ...action.event, isFetching: false },
        },
      };
      return newState;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
